module.exports = __webpack_public_path__ + "static/media/white-iphone-cercle.6b82aa6f.png";